export default (path: string): MenuSection => {
  if (path.startsWith('/heat-protection')) {
    return 'heatProtection'
  }
  if (path.startsWith('/administration')) {
    return 'administration'
  }
  return 'infectionProtection'
}
